import React, { useCallback, useEffect, useRef, useState } from 'react'
import Header from '../components/Header'
import HTMLFlipBook from 'react-pageflip'
import { pdfjs, Document, Page as ReactPdfPage } from 'react-pdf'

import measureIdentifyManage from '../assets/files/HCP 4th Edition APR 2024-min.pdf'
import growthFaltering from '../assets/files/IMFeD Summit Guidebook WEBSITE.pdf'
import { useParams } from 'react-router-dom'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const width = window.innerWidth > 600 ? 500 : 330
const height = window.innerWidth > 600 ? 640 : 420

const GUIDEBOOKS = {
  summit: {
    file: growthFaltering,
    fileName: 'IMFeD Summit Guidebook WEBSITE.pdf',
    pageCount: 56
  },
  hcp: {
    file: measureIdentifyManage,
    fileName: 'HCP 4th Edition APR 2024-min.pdf',
    pageCount: 40
  }
}

const Page = React.forwardRef(({ pageNumber, onAnnotations }, ref) => {
  return (
    <div ref={ref} className="page">
      <ReactPdfPage
        pageNumber={pageNumber}
        width={width}
        renderAnnotationLayer={true}
        onGetAnnotationsSuccess={onAnnotations}
      />
    </div>
  )
})

const ReadMe = ({ guidebookSlug: propSlug }) => {
  const { guidebookSlug: paramSlug } = useParams()
  const [currentPage, setCurrentPage] = useState(0)
  const pdfRef = useRef(null)
  const pendingLinksRef = useRef([])
  const flipBookRef = useRef()
  const slug = propSlug || paramSlug
  const selectedGuidebook = GUIDEBOOKS[slug] || GUIDEBOOKS.hcp

  const handlePageChange = e => {
    setCurrentPage(e.data)
  }

  const getFlipBookIndexForPdfPage = useCallback(
    pdfPage => {
      if (pdfPage === 'NextPage' || pdfPage === 'PrevPage') {
        const redirectTarget =
          pdfPage === 'NextPage' ? currentPage + 2 : currentPage - 2
        const limitZero = Math.max(0, redirectTarget)
        return limitZero
      } else {
        let result = 0
        if (pdfPage && pdfPage !== 1) {
          if (pdfPage % 2 === 0) {
            result = Math.floor(pdfPage - 1)
          } else {
            result = Math.floor(pdfPage)
          }
        }
        return result
      }
    },
    [currentPage]
  )

  const applyLinkHandlers = useCallback(
    (currentPage, linkData = pendingLinksRef.current) => {
      const match = linkData.filter(
        link => link.page === currentPage + 1 || link.page === currentPage + 2
      )

      for (const item of match) {
        const linkElement = document.querySelector(
          `a[data-element-id="${item.id}"]`
        )

        if (linkElement) {
          linkElement.style.cursor = 'pointer'
          linkElement.onclick = e => {
            e.preventDefault()
            const targetPage = getFlipBookIndexForPdfPage(item.targetPage)
            flipBookRef.current.pageFlip().flipController.flipToPage(targetPage)
          }
        }
      }
    },
    [getFlipBookIndexForPdfPage]
  )

  useEffect(() => {
    applyLinkHandlers(currentPage)
  }, [applyLinkHandlers, currentPage])

  useEffect(() => {
    setCurrentPage(0)
    pendingLinksRef.current = []
  }, [slug])

  return (
    <div>
      <Header />
      <div className="container ">
        <div>
          <Document
            file={selectedGuidebook.file}
            style={{ overflow: 'hidden' }}
            onLoadSuccess={pdf => (pdfRef.current = pdf)}
          >
            <HTMLFlipBook
              ref={flipBookRef}
              width={width}
              height={height}
              page={currentPage}
              onFlip={e => handlePageChange(e)}
              style={{
                overflow: 'hidden',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <Page key={1} pageNumber={1} />

              {Array.from(
                { length: selectedGuidebook.pageCount - 1 },
                (_, index) => {
                  const pageNumber = index + 2
                  return (
                    <Page
                      key={pageNumber}
                      pageNumber={pageNumber}
                      onAnnotations={async annotations => {
                        for (const [, annot] of annotations.entries()) {
                          if (
                            !pendingLinksRef.current.some(
                              l => l.id === annot.id
                            )
                          ) {
                            if (
                              annot.action === 'NextPage' ||
                              annot.action === 'PrevPage'
                            ) {
                              const inputObj = {
                                id: annot.id,
                                page: pageNumber,
                                targetPage: annot.action
                              }
                              pendingLinksRef.current.push(inputObj)

                              if (annot.id === '590R' || annot.id === '588R') {
                              }
                            }
                            if (annot.subtype === 'Link' && annot.dest) {
                              const dest = await pdfRef.current.getDestination(
                                annot.dest
                              )
                              const [ref] = dest
                              const targetIndex = await pdfRef.current.getPageIndex(
                                ref
                              )
                              const targetPage = targetIndex + 1

                              pendingLinksRef.current.push({
                                id: annot.id,
                                page: pageNumber,
                                targetPage
                              })
                            }
                          }
                        }

                        applyLinkHandlers(currentPage)
                      }}
                    />
                  )
                }
              )}
            </HTMLFlipBook>
          </Document>
        </div>
      </div>
    </div>
  )
}

export default ReadMe
